import { mapGetters } from 'vuex'
import i18n from 'services/i18n'
import { is } from 'core-js/core/object'

export const heroDataHelper = {
    computed: {
        ...mapGetters({
            packageInfo: 'User/getPackageInfo',
            isReportingAllowed: 'User/getIsReportingAllowed',
            currentLanguage: 'Languages/getSelectedCountryCode',
            isLoggedIn: 'isLoggedIn'
        }),
        isFiChatBotPackage () {
            return this.packageInfo.some(el => el.code === 'fi-chatbot' || el.code === 'fi-chatbot-trial')
        },
        slidesNumber () {
            return 3
        },
        slides () {
            switch (this.$totemLang) {
            case 'fi':
                return {
                    background: [
                        'linear-gradient(93deg, rgba(24, 87, 124, 0.85) 0%, rgba(33, 115, 141, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-galaxy.jpeg') + ')',
                        'linear-gradient(93deg, rgba(39, 49, 73, 0.85) 0%, rgba(63, 82, 119, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-geometric.jpeg') + ')',
                        'linear-gradient(93deg, rgba(35, 76, 115, 0.85) 0%, rgba(40, 107, 169, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-fireworks2.jpeg') + ')',
                    ],
                    videoSrc: '',
                    introType: ['image', 'image', 'image'],
                    buttonLink: [
                        {
                            name: '',
                        },
                        {
                            name: '',
                        },
                        {
                            name: 'collection-without-package',
                            params: { collectionSlug: '60370737-onnistu-ja-opi-podcast' }
                        },
                    ],
                    secondaryButtonLink: []
                }
            case 'se':
                return {
                    background: [
                        'linear-gradient(93deg, rgba(27, 77, 92, 0.85) 0%, rgba(33, 115, 141, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-geometric.jpeg') + ')',
                        'linear-gradient(93deg, rgba(39, 49, 73, 0.85) 0%, rgba(63, 82, 119, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-wave.jpeg') + ')',
                        'linear-gradient(93deg, rgba(35, 76, 115, 0.85) 0%, rgba(40, 107, 169, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-fireworks.jpeg') + ')'
                    ],
                    videoSrc: 'https://player.vimeo.com/video/897131387',
                    introType: ['image', 'image', 'video'],
                    buttonLink: [
                        {
                            name: 'all-content',
                            params: { packageSlug: 'se-ai' }
                        },
                        {
                            name: 'all-content',
                            params: { packageSlug: 'se-office-skills'}
                        },
                        { name: 'all-packages-learning-paths' }
                    ],
                    secondaryButtonLink: [{ name: 'course-without-package', params: { courseSlug: '6206237-ai-de-forsta-stegen' } }]
                }
            case 'no':
                // To be restored

                // return {
                //     background: [
                //         'linear-gradient(93deg, rgba(35, 76, 115, 0.85) 0%, rgba(40, 107, 169, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-galaxy.jpeg') + ')',
                //         'linear-gradient(93deg, rgba(27, 77, 92, 0.85) 0%, rgba(33, 115, 141, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-geometric.jpeg') + ')',
                //         'linear-gradient(93deg, rgba(35, 76, 115, 0.85) 0%, rgba(40, 107, 169, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-fireworks.jpeg') + ')'
                //     ],
                //     videoSrc: 'https://player.vimeo.com/video/897131357',
                //     introType: ['image', 'image', 'video'],
                //     buttonLink: [
                //         { name: '' },
                //         { name: 'all-content', params: { packageSlug: 'no-baerekraft' } },
                //         { name: 'all-packages-learning-paths' }
                //     ],
                //     secondaryButtonLink: []
                // }
                return {
                    background: [
                        'linear-gradient(93deg, rgba(24, 87, 124, 0.85) 0%, rgba(52, 119, 159, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-geometric2.jpeg') + ')',
                        'linear-gradient(93deg, rgba(35, 76, 115, 0.85) 0%, rgba(40, 107, 169, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-galaxy.jpeg') + ')',
                        'linear-gradient(93deg, rgba(27, 77, 92, 0.85) 0%, rgba(33, 115, 141, 0.85) 100%), url(' + require('@/assets/images/hero/hero-background-geometric.jpeg') + ')',
                    ],
                    videoSrc: '',
                    introType: ['image', 'image', 'image'],
                    buttonLink: [
                        { name: '' },
                        { name: '' },
                        { name: 'learning-path-page', params: { learningPathSlug: '15611149-cybersikkerhet', packageSlug: 'no-o365' } },
                    ],
                    secondaryButtonLink: []
                }
            }
        }
    },
    methods: {
        openVideoModal () {
            this.$modal.show('hero-video-modal')
        },
        translationExist (translation) {
            return i18n.te(translation)
        }
    }
}
